import { cn } from '@/lib/utils'
import { DetailText, HeadlineText, BodyText } from 'design-configuration/components'
import { motion } from 'motion/react'
import { exhibitionTransition } from './header'
import { ImageWithCustomLoader } from '@components/image-with-custom-loader'
import { useSoloViewer } from '@components/solo-viewer/provider'

export const MoreDetailsBlock = ({
  title,
  description
}: {
  title: string
  description: React.ReactElement
}): React.ReactElement => {
  return (
    <div className="gap-y-xs p-md bg-surface-container flex flex-col">
      <DetailText className="text-on-surface-variant font-medium uppercase">{title}</DetailText>
      {description}
    </div>
  )
}
export const WorksQuote = ({
  quote,
  author,
  image,
  alignText
}: {
  quote: React.ReactElement
  author: string
  image: string
  alignText: 'left' | 'right'
}): React.ReactElement => {
  const { setSoloViewerImageData } = useSoloViewer()
  return (
    <div
      className={cn(
        'gap-x-sm gap-y-md flex w-full flex-col items-center justify-between md:flex-row',
        alignText === 'right' ? 'md:flex-row-reverse' : ''
      )}
    >
      <motion.div
        className="px-md lg:px-2xl w-full md:w-1/2"
        initial={{ opacity: 0 }}
        whileInView={{ opacity: 1 }}
        transition={exhibitionTransition}
        viewport={{ once: true, amount: 0.2 }}
      >
        <HeadlineText className="font-light">{quote}</HeadlineText>
        <BodyText className="text-on-surface-variant pt-md">{author}</BodyText>
      </motion.div>
      <motion.button
        className="relative ml-auto aspect-[3/2] w-3/4 self-end md:ml-0 md:w-1/2"
        initial={{ opacity: 0 }}
        whileInView={{ opacity: 1 }}
        transition={exhibitionTransition}
        viewport={{ once: true, amount: 0.2 }}
        onClick={() => setSoloViewerImageData({ image, imageList: [image] })}
      >
        <ImageWithCustomLoader
          src={image}
          alt="Works quote photo"
          style={{
            objectFit: 'cover'
          }}
          sizes="50vw"
          fill
        />
      </motion.button>
    </div>
  )
}
